





























import { Component, Vue, Emit } from 'vue-property-decorator'
import { VImageUpload } from '@/components/upload'
import { CreateOriginStory, UpdateOriginStory } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { Message } from 'element-ui'

@Component({ components: { VImageUpload } })
export default class EditOriginStoryDialog extends Vue {
  private show = false
  private isEdit = false
  private data: any = {}
  private coverList: any[] = []
  private videoList: any[] = []
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    title: [this.requiredRule],
    coverUrl: [this.requiredRule],
    contentType: [this.requiredRule],
  }

  @Emit('close')
  private close() {
    this.show = false
  }

  public open(row: any, isEdit: boolean) {
    this.isEdit = isEdit
    this.data = {
      contentType: 0,
      isHomepage: 0,
      sort: 0,
      status: 1,
      ...row,
    }
    this.coverList = this.data.coverUrl ? [{ url: this.data.coverUrl }] : []
    this.videoList = this.data.videoUrl ? [{ url: this.data.videoUrl }] : []
    this.show = true
  }

  private onCoverChange(list: any[]) {
    this.coverList = list
    this.data.coverUrl = list && list.length ? list[0].url : ''
  }

  private onVideoChange(list: any[]) {
    this.videoList = list
    this.data.videoUrl = list && list.length ? list[0].url : ''
  }

  private save() {
    const f = this.$refs.form as ElForm
    f.validate(async (ok: boolean) => {
      if (!ok) return
      if (this.isEdit) {
        await UpdateOriginStory(this.data)
      } else {
        await CreateOriginStory(this.data)
      }
      Message.success('保存成功')
      this.close()
    })
  }
}
